// @ts-nocheck
import React from 'react';
import { pddQuestionApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default ({
  filter = {},
  disabledKeys = [],
  ...selectProps
}) => <AutocompleteSelect fetch={async params => {
  return await pddQuestionApi.fetch({
    ...filter,
    ...params
  });
}} refetchParams={{
  filter
}} fetchSingle={pddQuestionApi.get} notFoundText="Вопрос не найден" placeholder="Выберите вопрос" renderOption={(pddQuestion, Option) => <Option key={pddQuestion.id} value={pddQuestion.id} pddQuestion={pddQuestion} disabled={disabledKeys.includes(pddQuestion.id)} className={disabledKeys.includes(pddQuestion.id) ? 'ant-select-dropdown-menu-item-selected' : ''}>
        {pddQuestion.question}
      </Option>} {...selectProps} />;
